import { useEffect } from 'react'
import { formatLongDate } from 'shared/utils/format-date'
import { showNotificationToast } from 'shared/utils/notify'
import {
  DELETE_ACCOUNT_GRACE_PERIOD_DAYS,
  DELETE_ACCOUNT_SETTINGS
} from '../constants'
import { takeDeletionNotice } from '../utils/deletion-notice'

/**
 * Says when the account goes, after the reload that followed its deletion
 * request (FE-331). Mounted at the app root: the settings chunk is lazy and
 * the guest may land anywhere.
 */
export const AccountDeletionNoticeEffect = () => {
  useEffect(() => {
    const notice = takeDeletionNotice()
    if (!notice) return

    const { scheduledFor } = notice
    showNotificationToast({
      type: 'success',
      title: DELETE_ACCOUNT_SETTINGS.scheduledTitle,
      description:
        scheduledFor !== null ?
          `Your account will be deleted on ${formatLongDate(scheduledFor)}. Sign in before then to restore it.`
        : `Your account is scheduled for deletion. Sign in within ${DELETE_ACCOUNT_GRACE_PERIOD_DAYS} days to restore it.`
    })
  }, [])

  return null
}
